import React from 'react';

import AccountUserDetailLikeBrandLogModalView from './AccountUserDetailLikeBrandLogModalView';
import { useAccountUserDetailLikeBrandLogList } from '../hooks';

const AccountUserDetailLikeBrandLogModalContainer = (props) => {
  const { userId, actionLogType, closeModal, setActionLogType } = props;
  const { likeBrandLogList, filterOption, sortOption, pagination, getList } = useAccountUserDetailLikeBrandLogList({
    userId,
    actionLogType,
    setActionLogType,
  });

  return (
    <AccountUserDetailLikeBrandLogModalView
      closeModal={closeModal}
      likeBrandLogList={likeBrandLogList}
      filterOption={filterOption}
      sortOption={sortOption}
      pagination={pagination}
      getList={getList}
    />
  );
};

export default AccountUserDetailLikeBrandLogModalContainer;
